import React from "react";

function Navbar() {
    return ( 
        <>
    <nav className="navbar navbar-expand-lg navbar-light">
    <div className="container">
        <div className="navbar-brand">
            <img src="./images/logo.jpg" width="80px" height="50px"/>
        </div>
        <div>
            <p style={{fontSize:"larger", fontWeight: 900}}>Ana Cabs Point</p>
        </div>
        <div>
            
        </div>
    </div>
</nav>
<br/>
</> 
 );
}

export default Navbar;